// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2hKXV","footer":"ModalCreateQualiphyProcedure_footer__pnjeW","additionData":"ModalCreateQualiphyProcedure_additionData__3XQ03"};